import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import "@fontsource/inter/400.css"; // Regular weight
import "@fontsource/inter/600.css"; // Semi-bold weight
 
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GoogleOAuthProvider clientId="87989156529-ju8fsrfpktq93r8qdvamog13a9pf8vs7.apps.googleusercontent.com">
        <App />
      </GoogleOAuthProvider>                                    
    </ThemeProvider>
  </React.StrictMode>
);
